"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = sendFiles;
exports.SEND_FILES = void 0;
var SEND_FILES = 'WEB_CHAT/SEND_FILES';
exports.SEND_FILES = SEND_FILES;

function sendFiles(files) {
  return {
    type: SEND_FILES,
    payload: {
      files: files
    }
  };
}